// extracted by mini-css-extract-plugin
module.exports = {"root":"BigListWithBackgrounds-module--root--3du7d","list":"BigListWithBackgrounds-module--list--31tf1","item":"BigListWithBackgrounds-module--item--2HQ5f"};